import React from 'react'
import { Zoom, Grid, AlertProps } from '@mui/material'
import { getUserIdFromStorage } from '../../../utils/getTempUserId'
import { FormattedMessage } from 'react-intl'
import { CoreAlert } from '@thriveglobal/thrive-web-leafkit'

interface ErrorAlertProps extends AlertProps {
    show: boolean
    errorType?: ErrorAlertType
}

export type ErrorAlertType = 'DEFAULT' | 'MAGIC_LINK'

const ErrorAlert: React.FC<ErrorAlertProps> = ({
    show,
    errorType,
    ...alertProps
}) => {
    const tempUserId = getUserIdFromStorage()
    return (
        <Zoom in={show} mountOnEnter unmountOnExit>
            <Grid item sx={{ display: 'flex', justifyContent: 'center' }}>
                <CoreAlert
                    severity="error"
                    {...alertProps}
                    variant={alertProps.variant || 'filled'}
                >
                    {errorType === 'MAGIC_LINK' && (
                        <FormattedMessage
                            description="Catch all error for magic link error"
                            defaultMessage={
                                'This link has expired. To receive a new link, enter your email address. Code: {tempUserId}'
                            }
                            values={{
                                tempUserId
                            }}
                        />
                    )}
                    {errorType !== 'MAGIC_LINK' && (
                        <FormattedMessage
                            description="Generic error alert with tempUserId"
                            defaultMessage={
                                'Error. Please try again. Code: {tempUserId}'
                            }
                            values={{
                                tempUserId
                            }}
                        />
                    )}
                </CoreAlert>
            </Grid>
        </Zoom>
    )
}

export default ErrorAlert
